import React from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {BREADCRUMBS_STATISTIC} from './constants/breadcrumbs'
import Statistic from "@containers/statistic/Statistic";

const StatisticPage = () => {

    return (
        <PageLayout
            breadcrumbs={BREADCRUMBS_STATISTIC}
        >
            <Statistic/>
        </PageLayout>
    )
};

export default StatisticPage;